// extracted by mini-css-extract-plugin
export default {"title":"PK03dJKq","text":"L4mWSpcT"};